import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import DashboardCustomizeRoundedIcon from '@mui/icons-material/DashboardCustomizeRounded';
import Dialog from '../../../../Components/Dialog';
import MediaWidget from './MediaWidget';

const MediaDialog = function MediaDialog({
  open = false,
  onClose = () => {},
  onConfirm,
}) {
  const intl = useIntl();

  return (
    <Dialog
      id="template-editor"
      open={open}
      onClose={onClose}
      title={intl.messages.MEDIA}
      icon={
        <DashboardCustomizeRoundedIcon
          sx={{ fontSize: 24, color: 'white.main' }}
        />
      }
      fullScreen
      styles={{ content: { padding: 0 } }}
    >
      <MediaWidget handleSelectImg={onConfirm} />
    </Dialog>
  );
};

MediaDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default MediaDialog;
